import { useContext } from 'react';

import { OptimizelyContext } from '@optimizely/react-sdk';

import { FLAG } from 'Utilities/analytics/optimizely/constants';

import type { ValidOfferProps } from '../../acceptOffer/AcceptOffer.types';

import { DEALER_RATING_VARIATION_KEYS } from './DealerRatingsExperiment.helpers';
import { DealerRatingsExperimentTestKey } from './DealerRatingsExperimentTestKey';
import { useDealerRatingsExperiment } from './useDealerRatingsExperiment';

const PARENT_EXPERIMENT_KEY = FLAG.DEALER_RATINGS_MEASURING_EXPERIMENT;

export const DealerRatingsExperiment = ({
  offer,
  vehicleEnquiry,
}: {
  offer: ValidOfferProps['offer'];
  vehicleEnquiry: ValidOfferProps['vehicleEnquiry'];
}) => {
  const { optimizely } = useContext(OptimizelyContext);

  const {
    decisionAttributes,
    enabled,
    isEligibleForDealerRatingsExperiment,
    variationKey,
  } = useDealerRatingsExperiment({
    offer,
    vehicleEnquiry,
  });

  if (!enabled || !variationKey || !isEligibleForDealerRatingsExperiment) {
    return (null);
  }

  optimizely?.setForcedDecision(
    { flagKey: PARENT_EXPERIMENT_KEY },
    { variationKey },
  );

  optimizely?.decide(
    PARENT_EXPERIMENT_KEY,
    undefined,
    decisionAttributes.overrideUserId,
    decisionAttributes.overrideAttributes,
  );

  if (variationKey === DEALER_RATING_VARIATION_KEYS.TEST) {
    return (<DealerRatingsExperimentTestKey />);
  }

  return (null);
};
